import { z } from 'zod'

export const editionStageResponseSchema = z.object({
  data: z.object({
    stage: z.string(),
    paymentAllowed: z.boolean()
  })
})

export type EditionStageResponse = z.infer<typeof editionStageResponseSchema>
